import type { ApiSessionData } from '../api/types';

import { isEncryptedSessionStoreEnabled, isSessionStoreLocked } from './passcode/sessionStore';
import { requestSessionFromCrmChat } from './crmchat';
import { ACCOUNT_SLOT, storeAccountData } from './multiaccount';
import { lockPasscodeSessionStore } from './passcode';

export function hasStoredSession() {
  return true;
}

export function storeSession(_sessionData: ApiSessionData) {
  // CRM owns the session and its persistence
  return Promise.resolve();
}

export function clearStoredSession(_slot?: number) {
  // CRM owns the session and its removal
  return Promise.resolve();
}

export function clearAllStoredSessions() {
  if (isEncryptedSessionStoreEnabled()) {
    lockPasscodeSessionStore();
  }
}

export function loadStoredSession(): Promise<ApiSessionData> {
  return requestSessionFromCrmChat();
}

export function updateSessionUserId(currentUserId: string) {
  return storeAccountData(ACCOUNT_SLOT, { userId: currentUserId });
}

export function checkSessionLocked() {
  return isSessionStoreLocked();
}
